{
  "familyId": "SPR-LEEN-GRIEKS",
  "questions": [
    {
      "id": "SPR-LEEN-GRIEKS-001",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Welk woord komt uit het Grieks?",
      "options": ["psychologie", "restaurant", "computer", "bureau"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse leenwoorden", "content": "Woorden met 'psych-', 'phil-', 'theo-', 'bio-' komen uit het Grieks. Psychologie = psyche (ziel) + logos (leer).", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Psychologie komt uit het Grieks: psyche (ziel) + logos (leer/wetenschap). Restaurant is Frans, computer is Engels, bureau is Frans. Hoe herken je Griekse woorden? Let op voorvoegsels als psych-, bio-, theo-, phil- en achtervoegsels als -logie, -grafie, -scopie. Als je een onbekend woord tegenkomt, kijk dan of het zo'n Grieks woorddeel bevat.",
        "solutionSteps": ["Psychologie: psyche (Grieks: ziel) + logos (Grieks: leer)", "Restaurant = Frans, computer = Engels, bureau = Frans", "Herken Griekse voorvoegsels: psych-, bio-, theo-, phil-", "Check: bevat het woord een Grieks woorddeel? Zo ja → waarschijnlijk Grieks"],
        "distractorExplanations": {
          "0": "Goed! Psychologie komt uit het Grieks: psyche (ziel) + logos (leer). Het voorvoegsel psych- is een kenmerkend Grieks woorddeel.",
          "1": "Restaurant komt uit het Frans (restaurer = herstellen). Onthoud: -ant/-ent is vaak Frans.",
          "2": "Computer komt uit het Engels (to compute = berekenen). Onthoud: -er is vaak Engels.",
          "3": "Bureau komt uit het Frans. Onthoud: -eau is typisch Frans."
        }
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-002",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["filosofy", "fillosofie", "filosofie", "fylosofie"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse ph → f", "content": "In het Nederlands schrijven we Griekse woorden met 'f' in plaats van 'ph': philosophy → filosofie. De uitgang -y wordt in het Nederlands -ie.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_spelling_f",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijven we het Griekse 'ph' als 'f': philosophy → filosofie. De Engelse uitgang -y wordt in het Nederlands -ie. Let op: één l (filo-), niet twee (fillo-).",
        "solutionSteps": ["Grieks ph → Nederlands f", "Engelse -y → Nederlandse -ie", "Eén l: filo- (niet fillo-)", "Philosophy → filosofie"],
        "distractorExplanations": {
          "0": "Je hebt de Engelse uitgang -y gebruikt. In het Nederlands is het -ie: filosofie, niet filosofy. Onthoud: Engelse -y → Nederlandse -ie.",
          "1": "Je schreef een dubbele l: 'fillosofie'. Maar het Griekse woord heeft maar één l: philosophia → filosofie. Onthoud: filo- (één l), niet fillo-.",
          "2": "Goed! Filosofie — met f (niet ph) en -ie (niet -y). In het Nederlands passen we de Griekse spelling aan: ph wordt f.",
          "3": "Je schreef 'fy' in plaats van 'fi'. De Griekse 'ph' wordt in het Nederlands gewoon 'f', gevolgd door 'i': filosofie. Onthoud: ph → f, niet fy."
        }
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-003",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Wat betekent het Griekse voorvoegsel 'bio-'?",
      "options": ["aarde", "leven", "water", "lucht"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse voorvoegsels", "content": "bio- = leven (biologie = leer van het leven). geo- = aarde, hydro- = water, aero- = lucht.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_voorvoegsel",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bio- komt uit het Grieks en betekent 'leven'. Biologie = leer van het leven. Biograaf = schrijver over iemands leven. Andere Griekse voorvoegsels: geo- = aarde, hydro- = water, aero- = lucht. Een handige manier om ze te onthouden: denk aan een bekend woord met dat voorvoegsel en leid de betekenis daaruit af.",
        "solutionSteps": ["bio- = leven (Grieks: bios)", "biologie = leer van het leven", "biograaf = schrijver over iemands leven", "Onthoud-strategie: denk aan een bekend woord (biologie) om de betekenis af te leiden"],
        "distractorExplanations": {
          "0": "Aarde is 'geo-' in het Grieks (geografie = beschrijving van de aarde). Bio- = leven. Onthoud: bio = leven, geo = aarde.",
          "1": "Goed! Bio- = leven. Denk aan biologie (leer van het leven).",
          "2": "Water is 'hydro-' in het Grieks (hydraulisch = met water). Bio- = leven. Onthoud: bio = leven, hydro = water.",
          "3": "Lucht is 'aero-' in het Grieks (aerodynamisch = met lucht). Bio- = leven. Onthoud: bio = leven, aero = lucht."
        }
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-004",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN Grieks leenwoord?",
      "options": ["democratie", "telefoon", "theater", "garage"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Grieks vs. Frans", "content": "Garage is Frans (garer = bewaren). Democratie (demos = volk), telefoon (tele = ver, phone = geluid) en theater (theatron = schouwplaats) zijn Grieks.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_niet_grieks",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Garage komt uit het Frans (garer = bewaren/stallen). Democratie, telefoon en theater komen allemaal uit het Grieks. Hoe herken je het verschil? Griekse woorden bevatten vaak herkenbare woorddelen: demo- (volk), tele- (ver), -foon (geluid), thea- (kijken). Franse woorden herken je aan uitgangen als -age, -eur, -eau.",
        "solutionSteps": ["Garage = Frans (garer = bewaren)", "Democratie = Grieks (demos + kratia)", "Telefoon = Grieks (tele + phone)", "Theater = Grieks (theatron)"],
        "distractorExplanations": {
          "0": "Democratie is juist WEL Grieks: demos (volk) + kratia (macht) = volksmacht.",
          "1": "Telefoon is juist WEL Grieks: tele (ver) + phone (geluid) = ver geluid.",
          "2": "Theater is juist WEL Grieks: theatron = schouwplaats.",
          "3": "Goed! Garage is Frans (van 'garer' = bewaren/stallen). De uitgang -age is typisch Frans, net als bij 'bagage' en 'massage'."
        }
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-005",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks voorvoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "bio-", "right": "leven" },
          { "left": "geo-", "right": "aarde" },
          { "left": "tele-", "right": "ver" },
          { "left": "auto-", "right": "zelf" }
        ],
        "correctMatches": { "0": "0", "1": "1", "2": "2", "3": "3" }
      },
      "correctAnswer": { "0": "0", "1": "1", "2": "2", "3": "3" },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse voorvoegsels", "content": "bio- = leven (biologie), geo- = aarde (geografie), tele- = ver (telefoon), auto- = zelf (automatisch). Denk aan bekende woorden om de betekenis te onthouden.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_voorvoegsels_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De Griekse voorvoegsels en hun betekenis: bio- = leven (biologie = leer van het leven), geo- = aarde (geografie = beschrijving van de aarde), tele- = ver (telefoon = ver geluid), auto- = zelf (automatisch = vanzelf werkend). Onthoud ze door aan bekende woorden te denken!",
        "solutionSteps": ["bio- = leven (denk aan: biologie)", "geo- = aarde (denk aan: geografie)", "tele- = ver (denk aan: telefoon)", "auto- = zelf (denk aan: automatisch)"],
        "distractorExplanations": {}
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-006",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks voorvoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "mono-", "right": "één/alleen" },
          { "left": "poly-", "right": "veel" },
          { "left": "anti-", "right": "tegen" },
          { "left": "hyper-", "right": "boven/overmatig" },
          { "left": "micro-", "right": "klein" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Griekse voorvoegsels (2)",
            "content": "Nog meer Griekse voorvoegsels: mono- = één (monoloog = alleenspraak), poly- = veel (polygoon = veelhoek), anti- = tegen (antibiotica = tegen bacteriën), hyper- = boven/overmatig (hyperactief = overmatig actief), micro- = klein (microscoop = klein kijken).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "grieks_voorvoegsel_matching_2",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Griekse voorvoegsels en hun betekenis: mono- = één/alleen (monoloog = alleenspraak), poly- = veel (polygoon = veelhoek), anti- = tegen (antibiotica = tegen bacteriën), hyper- = boven/overmatig (hyperactief), micro- = klein (microscoop). Samen met de voorvoegsels uit de vorige vraag (bio-, geo-, tele-, auto-) ken je nu 9 Griekse voorvoegsels!",
        "solutionSteps": [
          "mono- = één (denk aan: monoloog = alleenspraak)",
          "poly- = veel (denk aan: polygoon = veelhoek)",
          "anti- = tegen (denk aan: antibiotica)",
          "hyper- = boven/overmatig (denk aan: hyperactief)",
          "micro- = klein (denk aan: microscoop)"
        ]
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-007",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks achtervoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "-logie", "right": "leer/wetenschap" },
          { "left": "-grafie", "right": "schrijven/beschrijven" },
          { "left": "-scopie", "right": "kijken/bekijken" },
          { "left": "-therapie", "right": "behandeling/genezing" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Griekse achtervoegsels",
            "content": "-logie = leer (biologie, psychologie). -grafie = schrijven (geografie, fotografie). -scopie = kijken (microscoop, telescoop). -therapie = behandeling (fysiotherapie).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "grieks_achtervoegsel_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Griekse achtervoegsels: -logie = leer/wetenschap (biologie, psychologie), -grafie = schrijven/beschrijven (geografie, fotografie), -scopie = kijken/bekijken (microscoop, telescoop), -therapie = behandeling/genezing (fysiotherapie). Als je een onbekend woord tegenkomt met zo'n achtervoegsel, kun je de betekenis afleiden uit het Griekse woorddeel.",
        "solutionSteps": [
          "Denk aan bekende woorden met elk achtervoegsel",
          "bio-logie = leer van het leven → -logie = leer",
          "geo-grafie = beschrijving van de aarde → -grafie = schrijven",
          "micro-scoop = klein kijken → -scopie = kijken"
        ]
      }
    }
  ]
}